var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 74,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 33.5v-14a17.5 17.5 0 1135 0v14m-42 0h49a7 7 0 017 7V65a7 7 0 01-7 7H9a7 7 0 01-7-7V40.5a7 7 0 017-7z",
    stroke: "#476FF2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjciIGhlaWdodD0iNzQiIHZpZXdCb3g9IjAgMCA2NyA3NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTE2IDMzLjVWMTkuNUMxNiAxNC44NTg3IDE3Ljg0MzcgMTAuNDA3NSAyMS4xMjU2IDcuMTI1NjNDMjQuNDA3NSAzLjg0Mzc0IDI4Ljg1ODcgMiAzMy41IDJDMzguMTQxMyAyIDQyLjU5MjUgMy44NDM3NCA0NS44NzQ0IDcuMTI1NjNDNDkuMTU2MyAxMC40MDc1IDUxIDE0Ljg1ODcgNTEgMTkuNVYzMy41TTkgMzMuNUg1OEM2MS44NjYgMzMuNSA2NSAzNi42MzQgNjUgNDAuNVY2NUM2NSA2OC44NjYgNjEuODY2IDcyIDU4IDcySDlDNS4xMzQwMSA3MiAyIDY4Ljg2NiAyIDY1VjQwLjVDMiAzNi42MzQgNS4xMzQwMSAzMy41IDkgMzMuNVoiCiAgICAgICAgc3Ryb2tlPSIjNDc2RkYyIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+";
export { SvgLock as ReactComponent };